import { SxProps, Theme } from '@mui/material';

const container: SxProps<Theme> = (theme) => ({
  padding: theme.spacing(0.25, 1),
  borderRadius: 1,
  border: `1px solid ${theme.palette.auxRed.main}`,
});

const text: SxProps<Theme> = (theme) => ({
  color: theme.palette.auxRed.main,
});

const styles = {
  container,
  text,
};

export default styles;
